module.exports = __webpack_public_path__ + "img/ksmxhrdcorpwhite.f773b91d.png";